export enum ContractedProjectGridField {
  projectName = "projectName",
  year = "year",
  isVisible = "isVisible",
}
